// extracted by mini-css-extract-plugin
export default {"nkSection":"NkSection_nkSection__04AZ4","blue":"NkSection_blue__7twvG","nkSectionContainer":"NkSection_nkSectionContainer__7K7Dw"};